import { Modal, ModalOverlay, ModalContent, ModalBody } from '@chakra-ui/react';
import { StepsProvider, Steps, useSteps } from 'react-step-builder';
import { useState } from 'react';
import { useMixpanel } from '@/hooks/use-mixpanel';

import { CreateFromScratchWithTitle } from './create-with-title/from-scratch';
import { CreateFromBlueprinthWithTitle } from './create-with-title/from-blueprint';

import { BlueprintListWithDetails } from './blueprint-list-with-details';

const OutreachSteps = ({ onClose = () => {}, quickCreate = false }) => {
  const { track } = useMixpanel();
  const { jump } = useSteps();
  const [blueprint, setBlueprint] = useState(null);

  const onStartFromScratch = () => {
    jump(2);
    track({
      event: 'outreach-create-from-scratch',
    });
  };

  const onCreateFromBlueprint = (blueprint) => {
    setBlueprint(blueprint);
    jump(3);
    track({
      event: 'outreach-create-from-blueprint',
    });
  };

  return (
    <Steps>
      <BlueprintListWithDetails
        onClose={onClose}
        onStartFromScratch={onStartFromScratch}
        onCreateFromBlueprint={onCreateFromBlueprint}
      />
      <CreateFromScratchWithTitle
        onBack={() => {
          jump(1);
        }}
        backText="Back to blueprints"
        onClose={onClose}
        quickCreate={quickCreate}
      />
      <CreateFromBlueprinthWithTitle
        blueprint={blueprint}
        onClose={onClose}
        quickCreate={quickCreate}
      />
    </Steps>
  );
};

export const CreateOutreach = ({
  isOpen = true,
  onClose = () => {},
  quickCreate = false,
  ...props
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="6xl"
      isCentered
      closeOnEsc={false}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalBody p="0" h="770px">
          <StepsProvider>
            <OutreachSteps
              onClose={onClose}
              quickCreate={quickCreate}
              {...props}
            />
          </StepsProvider>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
